
export const SECONDARY_NIBUD_API_KEY = "0d8a1537f5fb4dea986ecf3cff24592a"

export const NIBUD_OPTIONS_GENDER_ENDPOINT = "https://api.nibud.nl/pensioenuitgaven/geslacht"
export const NIBUD_OPTIONS_CAR_KILOMETERS_ENDPOINT = "https://api.nibud.nl/pensioenuitgaven/autokilometersperjaar"
export const NIBUD_OPTIONS_CAR_STATUS_ENDPOINT = "https://api.nibud.nl/pensioenuitgaven/statusauto"
export const NIBUD_OPTIONS_HOME_ENDPOINT = "https://api.nibud.nl/pensioenuitgaven/soortWoning"
export const NIBUD_OPTIONS_CAR_TYPE_ENDPOINT = "https://api.nibud.nl/pensioenuitgaven/typeauto"
export const NIBUD_OPTIONS_HOME_WOZ_ENDPOINT = "https://api.nibud.nl/pensioenuitgaven/woningWoz"
export const NIBUD_OPTIONS_HOME_TYPE_ENDPOINT = "https://api.nibud.nl/pensioenuitgaven/typewoning"
export const NIBUD_PENSION_RESULT_ENDPOINT = "https://api.nibud.nl/pensioenuitgaven/Resultaat"

export const twentyFourHoursInMs = 1000 * 60 * 60 * 24;